import Proj1 from "../assets/Easy-imc.png";
import Proj2 from "../assets/Flex-Turismos.png";
import Proj3 from "../assets/Gerador-de-pdf-ReclamaJus.png";
import Proj4 from "../assets/tela-login.png";


export const ProjectList = [
  {
    name: "Easy-imc calculadora de imc",
    image: Proj1,
    skills: "React, Styled-components, Contextapi, Modal",
    link: 'imc.js',
    perfil: 'gustavokozlowski'
  },
  {
    name: " Flex-Turismos Landing Page",
    image: Proj2,
    skills: "HTML, CSS & JavaScript",
    link: 'flex-turismos',
    perfil: 'gustavokozlowski'
  },
  {
    name: "Gerador-de-pdf-ReclamaJus",
    image: Proj3,
    skills: "HTML & CSS",
    link: 'gerador-pdf-reclamajus',
    perfil: 'iamcoursin'
  },
  {
    name: "Clone da Tela de login do instagram",
    image: Proj4,
    skills: "React",
    link: 'tela-de-login-instagram',
    perfil: 'gustavokozlowski',
  },
];